import { BACKEND_APIS } from "@constants"

export default function useBatchBackendApiPath() {
    return {
        executionStatus: `${BACKEND_APIS.BATCH}/execution-status`,
        multipleStatus: `${BACKEND_APIS.BATCH}/status-multiple` ,
        searchesBySiteUrl: `${BACKEND_APIS.BATCH}/status-per-site`,
        searchesByOffice: `${BACKEND_APIS.BATCH}/status-per-office`,
        forceUrl: `${BACKEND_APIS.INTERMEDIARY}/check/executions/batch/force`,
        retryUrl: `${BACKEND_APIS.INTERMEDIARY}/retry/executions`,
        backendUrl: BACKEND_APIS.BATCH ,
        searchUrl: BACKEND_APIS.SEARCH,
        searchesUrl: `${BACKEND_APIS.BATCH}/status`,
        reportType: "batches" ,
        historic: `${BACKEND_APIS.BATCH}/executions`,
    }
}